class BundleSave extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Smooth scroll voor buttons
		this.initSmoothScroll();
		
		// Accessibility verbeteringen
		this.initAccessibility();
		
		// Hover effecten
		this.initHoverEffects();
	}

	initSmoothScroll() {
		const buttons = this.querySelectorAll('.bundle-btn');
		buttons.forEach(button => {
			button.addEventListener('click', (e) => {
				// Voeg smooth scroll toe als de link naar een sectie op dezelfde pagina verwijst
				const href = button.getAttribute('href');
				if (href && href.startsWith('#')) {
					e.preventDefault();
					const target = document.querySelector(href);
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
					}
				}
			});
		});
	}

	initAccessibility() {
		// Voeg ARIA labels toe voor betere toegankelijkheid
		const card = this.querySelector('.bundle-card');
		if (card) {
			card.setAttribute('aria-label', 'Bundle & Save product showcase');
		}
	}

	initHoverEffects() {
		// Voeg extra hover effecten toe voor betere UX
		const buttons = this.querySelectorAll('.bundle-btn');
		buttons.forEach(button => {
			button.addEventListener('mouseenter', () => {
				button.style.willChange = 'transform';
			});
			
			button.addEventListener('mouseleave', () => {
				button.style.willChange = 'auto';
			});
		});
	}
}

// Registreer de custom element
customElements.define('bundle-save', BundleSave);
